import { render, staticRenderFns } from "./ProfileStatistics.vue?vue&type=template&id=6a1a9c9d&scoped=true"
import script from "./ProfileStatistics.vue?vue&type=script&lang=js"
export * from "./ProfileStatistics.vue?vue&type=script&lang=js"
import style0 from "./ProfileStatistics.vue?vue&type=style&index=0&id=6a1a9c9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a9c9d",
  null
  
)

export default component.exports